import { isApiError } from '@wix/da-http-client/pkg/request';
import { all, call, select, takeLatest } from 'redux-saga/effects';
import { writerPopupClosed } from '@wix/da-shared-react/pkg/WriterPopup/redux/actions';
import { getWriterDeviation } from '@wix/da-shared-react/pkg/WriterPopup/redux/selectors';
import { ModuleType } from '../../types/modules';
import { getModuleIdByModuleType } from '../selectors/modules';
import { runModuleInitActions } from './modules';
import { getProfileOwnerUser } from '../selectors/users';
import { requestPuppyGruser } from './gruserHelpers';

// When WriterPopup is closed, reload the drafts stream
export function* reloadDraftsSectionSaga(action) {
  // We only want to reload drafts section if the last edited deviation is a
  // draft (i.e. not published)
  const writerDeviation = yield select(getWriterDeviation);
  if (!writerDeviation || writerDeviation.isPublished) {
    return;
  }

  const moduleid = yield select(getModuleIdByModuleType, ModuleType.DRAFTS);
  const { username } = yield select(getProfileOwnerUser);

  // module/drafts does not return module object, just the moduleData
  const moduleData = yield call(
    requestPuppyGruser,
    {
      method: 'get',
      url: '/module/drafts/',
      params: {
        moduleid,
        username,
      },
    },
    undefined,
    'gruser'
  );

  if (moduleData && !isApiError(moduleData)) {
    yield runModuleInitActions({
      id: moduleid,
      type: ModuleType.DRAFTS,
      moduleData,
    });
  }
}

export default function* rootFeedSaga() {
  yield all([takeLatest(writerPopupClosed, reloadDraftsSectionSaga)]);
}
